import React, { useEffect, useRef, useState } from 'react'
import { motion, AnimatePresence } from 'framer-motion'
import { Link } from 'react-router-dom'
import '../styles/components/Hero.css'

const Hero = () => {
  const heroRef = useRef(null)
  const [currentTaglineIndex, setCurrentTaglineIndex] = useState(0)

  // Curated powerful taglines - Best performers only
  const taglines = [

           {
      text: "We Turn Days of Manual Approvals into Seconds of Automated Precision",
      highlight: "Seconds of Automated",
      icon: "💰"
    },
            {
      text: "Your Business Runs on Paper. Your Competitors Run on Software",
      highlight: "Competitors Run on Software",
      icon: "🚀"
    },
    {
      text: "Your Business is Closed. Your Competitor Software is not Closed",
      highlight: "Competitor Software is not",
      icon: "⏰"
    },
   
         {
      text: "Let’s not Just Digitize Your Work. Let’s Redesign it For Profit and Scale",
      highlight: "Redesign it For Profit",
      icon: "⚡"
    },
  
   {
      text: "Digital Transformation is not IT, It’s Your Next Competitive Advantage",
      highlight: "Your Next Competitive",
      icon: "⚡"
    },
    {
      text: "Your Competitors are Digitizing While You Are Still Using Spreadsheets",
      highlight: "Are Still Using",
      icon: "⚡"
    },

       {
      text: "Your Data is Trapped in Silos. We Set it Free And Make it Work For You",
      highlight: "Set it Free And",
      icon: "⚡"
    },


    
       {
      text: "We Diagnoses Operational Chaos & Prescribes The Right Digital Systems",
      highlight: "Prescribes The Right",
      icon: "💰"
    }, 
         {
      text: "We Turn Fragmented Ops Into one Integrated Digital Backbone",
      highlight: "Fragmented Ops Into one",
      icon: "💰"
    },
         {
      text: "Paper Hides Problems. Digital Systems Expose and Fix them",
      highlight: " Digital Systems Expose",
      icon: "💰"
    },
    {
      text: "Donors Want Real-time Impact Data. When's your Excel Last Updated?",
      highlight: " Real-time Impact Data",
      icon: "💰"
    },
      {
      text: "From Paper Chaos to Digital Clarity in 90 days. Guaranteed",
      highlight: "Digital Clarity in 90 days",
      icon: "💰"
    },
   
              {
      text: "For Improvement, We Give You The Dashboards to See Your Wins & Leak",
      highlight: " We Give You The Dashboards",
      icon: "💰"
    },
    {
      text: "Manual Today. Automated Tomorrow. Dominant Forever.",
      highlight: "Dominant Forever",
      icon: "👑"
    },
   {
      text: "We Don't Just Build Apps. We Kill Inefficiency.",
      highlight: "Kill Inefficiency",
      icon: "⚡"
    }, 
    {
      text: "Looking Manual Means Looking Unbankable and Uninvestable ",
      highlight: "Means Looking Unbankabl",
      icon: "💰"
    }, 
  

    {
      text: "Turn Chaos into Code. Turn Code into Cash",
      highlight: "Code into Cash",
      icon: "💎"
    },
    {
      text: "Stop Losing Money to Manual Processes",
      highlight: "Losing Money",
      icon: "🛑"
    },
     {
      text: "From Paper Chaos to Digital Clarity",
      highlight: "Chaos to Digital Clarity",
      icon: "🛑"
    },
   
    //    {
    //   text: "Your manager spent 3 hrs creating a report that software generates in 3 seconds",
    //   highlight: "3 hours creating a report that software",
    //   icon: "👑"
    // },
  
  ]

  // Auto-rotate taglines
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentTaglineIndex((prev) => (prev + 1) % taglines.length)
    }, 9000) // Change every 4 seconds

    return () => clearInterval(interval)
  }, [taglines.length])

  // Mouse tracking removed for better performance

  const stats = [
    { number: '11+', label: 'Digital Services' },
    { number: '20+', label: 'Industries We Serve' },
    { number: '90', label: 'Day Transformation' }
  ]

  return (
    <>
    <section className="hero" ref={heroRef}>
      <div className="hero-background">
        <div className="grid-overlay"></div>
        <div className="floating-orb orb-1"></div>
        <div className="floating-orb orb-2"></div>
        <div className="floating-orb orb-3"></div>
      </div>

      <div className="hero-container">
        <div className="hero-content">
          {/* Badge */}
          <motion.div
            className="hero-badge"
            initial={{ opacity: 0, scale: 0.8 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.5, type: "spring", stiffness: 100 }}
          >
            <div className="badge-glow"></div>
            <span className="badge-icon">✨</span>
            <span className="badge-text">Transforming Businesses Globally</span>
          </motion.div>

          {/* Main Title with Rotating Text */}
          <motion.h1
            className="hero-title"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.1 }}
          >
            <AnimatePresence mode="wait">
              <motion.span
                key={currentTaglineIndex}
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -20 }}
                transition={{ duration: 0.5 }}
                className="title-with-animation"
              >
                {taglines[currentTaglineIndex].text.split(taglines[currentTaglineIndex].highlight).map((part, index, array) => (
                  <React.Fragment key={index}>
                    {part}
                    {index < array.length - 1 && (
                      <span className="gradient-text">{taglines[currentTaglineIndex].highlight}</span>
                    )}
                  </React.Fragment>
                ))}
              </motion.span>
            </AnimatePresence>
          </motion.h1>

          {/* Subtitle */}
          <motion.p
            className="hero-subtitle"
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            From innovative software development to intelligent AI automation—we create digital experiences that drive real business growth across Nigeria and beyond.
          </motion.p>

          {/* Action Buttons */}
          <motion.div
            className="hero-actions"
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.3 }}
          >
            <Link to="/contact" className="primary-button">
              <span>Start Your Project</span>
              <span className="button-icon">→</span>
            </Link>
            <Link to="/services" className="secondary-button">
              <span className="button-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 17L12 22L22 17" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M2 12L12 17L22 12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <span>Explore Services</span>
            </Link>
          </motion.div>

          {/* Trust Indicators */}
          {/* <motion.div
            className="trust-indicators"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            transition={{ duration: 0.8, delay: 0.6 }}
          >
            <div className="trust-line"></div>
            <p className="trust-text">Trusted by innovative businesses across</p>
            <div className="trust-badges">
              <span className="trust-badge">🇳🇬 Nigeria</span>
              <span className="trust-badge">🇺🇸 USA</span>
              <span className="trust-badge">🇬🇧 UK</span>
              <span className="trust-badge">🌍 Global</span>
            </div>
          </motion.div> */}
        </div>

        {/* Hero Visual Elements */}
        <div className="hero-visual">
          {/* Profile Card 1 with Badge */}
          <div className="profile-card profile-1">
            <div className="profile-image-wrapper">
              <div className="profile-badge success">✓ Expert Team</div>
              <img
                src="https://images.unsplash.com/photo-1580894894513-541e068a3e2b?w=400&auto=format&fit=crop&q=80"
                alt="Team member"
                className="profile-img"
              />
              <div className="profile-score">Pro</div>
            </div>
          </div>

          {/* AI Card */}
          <div className="ai-card">
            <div className="ai-icon">
              <img src="/figo-logo9.png" alt="Figo" className="ai-logo" />
            </div>
            <div className="ai-text">Figo AI</div>
          </div>

          {/* Greeting Card */}
          <div className="greeting-card">
            <div className="greeting-main">90-Day Transformation</div>
            <div className="greeting-stats">
              <div className="greeting-stat">
                <span className="stat-value">End</span>
                <span className="stat-desc">To End</span>
              </div>
              <div className="greeting-stat">
                <span className="stat-value">Full</span>
                <span className="stat-desc">Support</span>
              </div>
            </div>
          </div>

          {/* Profile Card 2 */}
          <div className="profile-card profile-2">
            <div className="profile-image-wrapper">
              <img
                src="https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?w=400&auto=format&fit=crop&q=80"
                alt="Team member"
                className="profile-img"
              />
              <div className="profile-score">Sr.</div>
            </div>
            <div className="profile-info-icon">ℹ️</div>
          </div>

          {/* Skills Card */}
          <div className="skills-card">
            <div className="skills-header">
              <span className="skills-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <defs>
                    <linearGradient id="chartGradient" x1="0%" y1="0%" x2="100%" y2="100%">
                      <stop offset="0%" stopColor="#4F6FFF" />
                      <stop offset="100%" stopColor="#7B5FFF" />
                    </linearGradient>
                  </defs>
                  <path d="M3 3V21H21" stroke="url(#chartGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M7 14L11 10L15 14L21 8" stroke="url(#chartGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path d="M17 8H21V12" stroke="url(#chartGradient)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
              <span className="skills-title">Our Expertise</span>
            </div>
            <div className="skills-metrics">
              <div className="skill-metric">
                <span className="metric-label">Software Dev</span>
                <div className="metric-bar-container">
                  <div className="skill-bar bar-1"></div>
                </div>
                <span className="metric-value">Expert</span>
              </div>
              <div className="skill-metric">
                <span className="metric-label">AI & Automation</span>
                <div className="metric-bar-container">
                  <div className="skill-bar bar-2"></div>
                </div>
                <span className="metric-value">Advanced</span>
              </div>
              <div className="skill-metric">
                <span className="metric-label">Digital Strategy</span>
                <div className="metric-bar-container">
                  <div className="skill-bar bar-3"></div>
                </div>
                <span className="metric-value">Expert</span>
              </div>
            </div>
          </div>

          {/* Projects Card */}
          <div className="projects-card">
            <div className="projects-title">What We Deliver</div>
            <div className="projects-list">
              <div className="project-item">
                <span className="project-status success">✓</span>
                <span className="project-name">Automated Workflows</span>
              </div>
              <div className="project-item">
                <span className="project-status success">✓</span>
                <span className="project-name">Real-time Dashboards</span>
              </div>
              <div className="project-item">
                <span className="project-status success">✓</span>
                <span className="project-name">Audit-Ready Systems</span>
              </div>
            </div>
          </div>

          {/* Robot Mascot */}
          <div className="robot-mascot">
            <div className="robot-body">🤖</div>
          </div>
        </div>

      </div>
    </section>

    {/* Stats Section - Separate from Hero */}
    <section className="stats-section">
      <div className="stats-section-container">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="stat-card"
          >
            <span className="stat-card-number">{stat.number}</span>
            <span className="stat-card-label">{stat.label}</span>
          </div>
        ))}
      </div>
    </section>
    </>
  )
}

export default Hero
